import { render, staticRenderFns } from "./ProfileVerifyModal.vue?vue&type=template&id=5a8802e6"
import script from "./ProfileVerifyModal.vue?vue&type=script&lang=js"
export * from "./ProfileVerifyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports